import { Component, OnInit,Inject,ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDialog } from "@angular/material";
import { ProductsComponent } from "../products/products.component";
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { ProductsService } from '../../services/products.service';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
@Component({
  selector: 'app-updateproduct',
  templateUrl: './updateproduct.component.html',
  styleUrls: ['./updateproduct.component.css']
})
export class UpdateproductComponent implements OnInit {
  productInfo : any;
  addProductForm: FormGroup;
  fileName: string = "";
  constructor(
    private dialogRef: MatDialogRef<ProductsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private productService: ProductsService,
    private cd: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private http: HttpClient,
  ) { }

  ngOnInit() {
    this.productInfo = this.data;
    this.addProductForm = this.fb.group({
      SubCategoryProfilePic: [''],
      ProductName: new FormControl('', [Validators.required]),
      Brand: new FormControl('', [Validators.required]),
      description:  new FormControl('', [Validators.required]),
      quantity: new FormControl('', [Validators.required]),
      MRP_Price: new FormControl('', [Validators.required]),
      VMART_Price:new FormControl('', [Validators.required]),
      Netweight:""
    })
    
    this.updatePatchValues();
    console.log(this.productInfo);
  }
  numericOnly(event) {    
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  updatePatchValues(){
    this.addProductForm.patchValue({
      ProductName : this.data.ProductName,
      Brand : this.data.Brand,
      MRP_Price : this.data.MRP_Price,
      VMART_Price : this.data.VMART_Price,
      Netweight : this.data.Netweight,
      quantity : this.data.stockquantity,
      description : this.data.description
    })

    this.fileName = this.data.ProductImage.substring(this.data.ProductImage.lastIndexOf("\/")+1);

  }
  fileProgress(event: any) {
    let reader = new FileReader(); // HTML5 FileReader API
    let file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);

      // When file uploads set it to file formcontrol
      reader.onload = () => {
        this.addProductForm.get('SubCategoryProfilePic').setValue(file);
        this.fileName = file.name
      }
      // ChangeDetectorRef since file is loading outside the zone
      this.cd.markForCheck();
    }
  }
  updateProduct(){
    const productDetails = new FormData();
    productDetails.append("productimage", this.addProductForm.get("SubCategoryProfilePic").value);
    let payLoad = { ...this.addProductForm.value };
    delete payLoad.SubCategoryProfilePic;
    payLoad.ProductID = this.data.ProductID;
    payLoad.Product_Status = this.data.Product_Status;
    console.log(payLoad);
    productDetails.append("updateproductInfo", JSON.stringify(payLoad));
    let token = localStorage.getItem('token');
    this.productService.adminUpdateProductInfo(productDetails, token).subscribe((res) => {
      console.log("Res", res)
      if (res.response == 3) {
        this.openSnackBar(res.message, "");
        this.dialogRef.close(true);
      } else {
        this.openSnackBar(res.message, "");
        this.dialogRef.close(false);
      }
    }, (err) => {
      console.log("error", err)
    })
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
  
  closeTab() {
    this.dialogRef.close(false);
  }

}
